// import data from './data'
import thunk from 'redux-thunk';
import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import {
  detailsProductReducer,
  productListReducer,
} from './reducers/productReducers';
import { cartReducer } from './reducers/cartReducers';
import { orderComReducer, orderDetailsReducer } from './reducers/orderReducers';
import { idReducer } from './reducers/idReducers';
import { storeReducer } from './reducers/storeReducers';
import { payMethodReducer } from './reducers/payMethodReducers';
import { addUserReducer } from './reducers/userReducers';
import { edenredReducer } from './reducers/edenredReducers';
import { conecsReducer } from './reducers/conecsReducers';
import { cbReducers } from './reducers/cbReducers';
import { scanReducers } from './reducers/scanReducers';
import { themeReducer } from './reducers/themeReducers';
import { themeDefault } from './utils/theme_default';
import { phoneReducer } from './reducers/phoneReducers';
import { midiDealReducer } from './reducers/midiDealReducers';
import { pikkoJackpotReducer } from './reducers/pikkoJackpotReducers';

const cartItemsLocal = localStorage.getItem('cartItems')

const pikkoJackpotFromStorage = (() => {
  try {
    const stored = localStorage.getItem('pikkoJackpot');
    return stored ? { offer: JSON.parse(stored) } : {};
  } catch {
    return {};
  }
})();

const initialState = {
  cart: {
    cartItems: (() => {
      try {
        const stored = localStorage.getItem('cartItems');
        if (!stored || stored === 'undefined') return null;

        const parsed = JSON.parse(stored);
        return parsed === undefined ? null : parsed;
      } catch (error) {
        console.error('Erreur lors du parsing de cartItems:', error);
        return null;
      }
    })(),
    stripeApplePayLoading: true,
  },
  store: (() => {
    try {
      const stored = localStorage.getItem('store');
      if (!stored) return {};

      const parsed = JSON.parse(stored);
      if (parsed === null || parsed === undefined || typeof parsed !== 'object') {
        console.info('store returns {}')
        return {};
      }

      return parsed;
    } catch (error) {
      console.error('Erreur lors du parsing de store:', error)
      localStorage.removeItem('store');
      return {};
    }
  })(),
  id: localStorage.getItem('id') ? JSON.parse(localStorage.getItem('id')) : {},
  productList: {
    products:
      localStorage.getItem('products') === 'undefined'
        ? []
        : JSON.parse(localStorage.getItem('products'))
  },
  orderDetails: localStorage.getItem('orderDetails')
    ? JSON.parse(localStorage.getItem('orderDetails'))
    : [],
  payMethod: localStorage.getItem('payMethod')
    ? JSON.parse(localStorage.getItem('payMethod'))
    : {},

  user: localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : {
      creditCard: {},
      conecs: {},
      edenred: {},
      usedPromo: [],
    },

  edenred: localStorage.getItem('Edenred')
    ? JSON.parse(localStorage.getItem('Edenred'))
    : {},

  conecs: localStorage.getItem('Conecs')
    ? JSON.parse(localStorage.getItem('Conecs'))
    : {},

  creditCard: localStorage.getItem('creditCard')
    ? JSON.parse(localStorage.getItem('creditCard'))
    : {},

  scanner: localStorage.getItem('scanner')
    ? JSON.parse(localStorage.getItem('scanner'))
    : {},

  theme: {
    theme: JSON.parse(localStorage.getItem('theme')) || themeDefault,
    loading: false,
  },
  jackpot: pikkoJackpotFromStorage,
};

const reducer = combineReducers({
                                  orderDetails: orderDetailsReducer,
                                  cart: cartReducer,
                                  productList: productListReducer,
                                  productDetails: detailsProductReducer,
                                  orderCom: orderComReducer,
                                  id: idReducer,
                                  store: storeReducer,
                                  payMethod: payMethodReducer,
                                  user: addUserReducer,
                                  edenred: edenredReducer,
                                  conecs: conecsReducer,
                                  creditCard: cbReducers,
                                  scanner: scanReducers,
                                  theme: themeReducer,
                                  phone: phoneReducer,
                                  midiDeal: midiDealReducer,
                                  jackpot: pikkoJackpotReducer,
                                });

const composeEnhance =
  process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;


const store = createStore(
  reducer,
  initialState,
  composeEnhance(applyMiddleware(thunk)),
);
// DISPATCH USER INITIAL PROMO STATE

export default store;
